import React from 'react';
import {
  Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay,
} from '@chakra-ui/react';
import { useQueryClient } from 'react-query';
import RnwyEnrollPanel from './forms/RnwyEnrollPanel';

// item 737 (Chad) — one reusable enroll modal so a sold subscription can be enrolled from
// ANYWHERE it surfaces: the Recurring page's pending list, the project's Subscriptions section,
// and the Proposals ⋮ menu. It wraps the same guided RnwyEnrollPanel (admin-gated, self-fetches
// its pre-fill), so the flow + Stripe behavior are identical wherever you launch it.
const EnrollSubscriptionModal: React.FC<{
  proposalId?: string;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  onEnrolled?: () => void;
}> = ({
  proposalId, isOpen, onClose, title, onEnrolled,
}) => {
  const queryClient = useQueryClient();
  const closeAndRefresh = () => {
    onClose();
    queryClient.invalidateQueries('recurringRevenue');
    queryClient.invalidateQueries('project');
    queryClient.invalidateQueries('projects');
    queryClient.invalidateQueries('proposals');
    onEnrolled?.();
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title ?? 'Enroll subscription'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {isOpen && proposalId && (
            <RnwyEnrollPanel proposalId={proposalId} enabled onEnrolled={closeAndRefresh} />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

EnrollSubscriptionModal.defaultProps = {
  proposalId: undefined,
  title: undefined,
  onEnrolled: undefined,
};

export default EnrollSubscriptionModal;
